import React, { useState, useEffect } from 'react';
import './PeriodSelector.css';

/**
 * Компонент для выбора периода или интервала месяцев
 */
export function PeriodSelector({ onSelect, mode = 'single' }) {
  const [startYear, setStartYear] = useState(new Date().getFullYear());
  const [startMonth, setStartMonth] = useState(new Date().getMonth() + 1);
  const [endYear, setEndYear] = useState(new Date().getFullYear());
  const [endMonth, setEndMonth] = useState(new Date().getMonth() + 1);

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let y = 2022; y <= currentYear; y++) {
    years.push(y);
  }

  const months = [
    { value: 1, label: 'Январь' },
    { value: 2, label: 'Февраль' },
    { value: 3, label: 'Март' },
    { value: 4, label: 'Апрель' },
    { value: 5, label: 'Май' },
    { value: 6, label: 'Июнь' },
    { value: 7, label: 'Июль' },
    { value: 8, label: 'Август' },
    { value: 9, label: 'Сентябрь' },
    { value: 10, label: 'Октябрь' },
    { value: 11, label: 'Ноябрь' },
    { value: 12, label: 'Декабрь' }
  ];

  const handleSelect = () => {
    if (mode === 'single') {
      const period = `${startYear}-${String(startMonth).padStart(2, '0')}`;
      onSelect(period);
    } else {
      const start = `${startYear}-${String(startMonth).padStart(2, '0')}`;
      const end = `${endYear}-${String(endMonth).padStart(2, '0')}`;
      onSelect({ start, end });
    }
  };

  return (
    <div className="period-selector">
      <div className="period-row">
        <label>
          {mode === 'range' ? 'С:' : 'Период:'}
        </label>
        <select
          value={startYear}
          onChange={(e) => setStartYear(parseInt(e.target.value))}
          className="period-select"
        >
          {years.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <select
          value={startMonth}
          onChange={(e) => setStartMonth(parseInt(e.target.value))}
          className="period-select"
        >
          {months.map(m => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
      </div>

      {mode === 'range' && (
        <div className="period-row">
          <label>По:</label>
          <select
            value={endYear}
            onChange={(e) => setEndYear(parseInt(e.target.value))}
            className="period-select"
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          <select
            value={endMonth}
            onChange={(e) => setEndMonth(parseInt(e.target.value))}
            className="period-select"
          >
            {months.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>
      )}

      <button onClick={handleSelect} className="btn-select">
        {mode === 'range' ? 'Показать интервал' : 'Выбрать'}
      </button>
    </div>
  );
}
